import React, { useState } from 'react';
import api from './api';
import AbsencesPanel from './AbsencesPanel';
import SignaturePad from './SignaturePad';
import { useFermerAvecEchap, userDisplayName } from './helpers';

function ProfileModal({ user, users = [], onClose }) {
  useFermerAvecEchap(onClose);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 6) {
      setError('Le nouveau mot de passe doit contenir au moins 6 caractères.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('La confirmation ne correspond pas au nouveau mot de passe.');
      return;
    }

    setSaving(true);
    try {
      await api.put(`/users/${user.id}/password`, { currentPassword, newPassword });
      setSuccess(true);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.response?.data?.message || 'Impossible de changer le mot de passe.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 640 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{ margin: 0 }}>Mon profil</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div style={{ marginBottom: 16, fontSize: 13, color: 'var(--text-secondary)' }}>
          <strong style={{ color: 'var(--text-primary)' }}>{userDisplayName(users.find((u) => u.id === user.id) || user)}</strong>
          {' · '}{user.username} · {user.email || 'Aucun email renseigné'}
        </div>

        {/* Rotations : chacun déclare ses propres périodes de repos et son
            intérimaire. C'est ce qui évite qu'une tâche ou une validation
            reste sans titulaire pendant dix jours. */}
        <h3 style={{ marginBottom: 10 }}>Ma signature</h3>
        <div style={{ marginBottom: 22 }}>
          <SignaturePad user={user} />
        </div>

        <h3 style={{ marginBottom: 10 }}>Mes rotations</h3>
        <div style={{ marginBottom: 22 }}>
          <AbsencesPanel currentUser={user} users={users} compact />
        </div>

        <h3 style={{ marginBottom: 10 }}>Changer mon mot de passe</h3>

        {error && <div className="error-message" style={{ marginBottom: 14 }}>{error}</div>}
        {success && (
          <div className="error-message" style={{ marginBottom: 14, background: 'rgba(76,175,80,0.12)', color: '#3d8b41', borderColor: 'rgba(76,175,80,0.3)' }}>
            Mot de passe mis à jour avec succès.
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Mot de passe actuel</label>
            <input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Nouveau mot de passe</label>
            <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength={6} />
          </div>
          <div className="form-group">
            <label>Confirmer le nouveau mot de passe</label>
            <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={6} />
          </div>

          <div className="modal-footer">
            <button type="button" className="btn" onClick={onClose}>Fermer</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Enregistrement...' : 'Mettre à jour'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProfileModal;
